<template>
    <!-- добавляет padding если отображается детальная карта и ширина страницы <640 -->
    <div class="map" :class="{ 'map--padded': cardSettingsStore.store._state.data.landPLotStore.currentSectionZone && cardSettingsStore.MAP_DOM_RECT.width < 640 }">
        <div class="master-plan">
            <MapFigure />
        </div>
        <MapHeader
            @openList="isListMobWindowVisible = !isListMobWindowVisible"
            @changeTab="changeTab"
            :class="{ 'map-header--map': !isMasterPlan }"
        />

        <MapFooter v-if="isMasterPlan" />

        <ListMobWindow
            v-if="isListMobWindowVisible"
            @close="isListMobWindowVisible = false"
        />

        <CardHouse />

        <CardPlotZone />

        <LandPLotModal
            @close="onCloseHouseWindow"
            @openFilter="isListMobWindowVisible = true"
            v-if="isWindowHouseWindowVisible"
        />

        <SliderFullScreen v-if="galleryStore.SHOW_MODAL" />
    </div>
</template>

<script setup lang="ts">
    import { computed, ref } from 'vue';
    import MapHeader from '@/components/map/MapHeader.vue';
    import MapFooter from '@/components/map/MapFooter.vue';
    import MapFigure from '@/components/map/MapFigure.vue';
    import ListMobWindow from '../modals/ListMobWindow.vue';
    import CardHouse from '@/components/house/CardHouse.vue';
    import CardPlotZone from '@/components/map/map-sections/CardPlot.vue';
    import LandPLotModal from '@/components/modals/LandPlot/index.vue';
    import SliderFullScreen from '@/components/modals/SliderFullScreen.vue';
    import { cardSettingsStore } from '@/store/modules/CardSettings';
    import { galleryStore } from '@/store/modules/Gallery';

    let isListMobWindowVisible = ref(false);
    let isMasterPlan = ref(true);

    const isWindowHouseWindowVisible = computed(() => {
        return cardSettingsStore.IS_SHOW_LAND_PLOT_CARD_IN_MODAL;
    });

    function changeTab(data: string) {
        isMasterPlan.value = data === 'map-plan' ? false : true;
    }

    function onCloseHouseWindow() {
        cardSettingsStore.LAND_PLOT_CARD_IN_MODAL_SET_SHOW_STATUS(false);
    }
</script>

<style lang="less">
    .map {
        max-width: 100vw;
    }

    .map--padded{
        padding-top: 50px;
        padding-bottom: 60px;
    }
</style>
